import React, { Fragment } from 'react'
import { Field, FieldArray } from 'redux-form/immutable'

import Input from 'app/components/Input'
import Delete from 'app/components/SVGS/Delete'
import IconButton from 'app/domains/common/IconButton'
import Button from 'app/components/ButtonDefault'
import Divider from 'app/components/Divider'
import { trimmed } from 'helpers/reviews'
import { IReviewsSurveyCompetenciesSectionProps } from './interface'
import ReviewsSurveyOpenEndedQuestionSection from '../ReviewsSurveyOpenEndedQuestionSection'
import { initialCompetency } from '../../ReviewsSurveyCreate'

import './styles.scss'

const bc = 'reviews-survey-competencies-section'

const ReviewsSurveyCompetenciesSection: React.FC<IReviewsSurveyCompetenciesSectionProps> = ({
  fields,
  validateTextArea,
  validateCompetencyTextArea,
  isPublished,
  t,
}) => {
  return (
    <Fragment>
      {fields.map((member: string, index: number) => {
        return (
          <div key={`${fields.name}.${index}`}>
            <div className={`${bc}__title`}>
              <h3 style={{ marginRight: '8px' }}>{t('Competency', { number: index + 1 })}</h3>
              {index > 2 && (
                <IconButton
                  onClick={() => fields.remove(index)}
                  disabled={isPublished}
                  title={isPublished ? t('Button is disabled because survey already is published') : undefined}
                >
                  <Delete />
                </IconButton>
              )}
            </div>
            <Field
              name={`${member}.name`}
              component={Input}
              label={t('Competency Name')}
              placeholder={t('Write Competency Name')}
              validate={validateCompetencyTextArea}
              disabled={isPublished}
              normalize={trimmed}
            />
            <FieldArray
              name={`${member}.questions`}
              // @ts-ignore
              component={ReviewsSurveyOpenEndedQuestionSection}
              min={1}
              validateTextArea={validateTextArea}
              isPublished={isPublished}
            />
            <Divider margin="0 0 32px 0" padding="32px 0 0 0" />
          </div>
        )
      })}
      <Button
        xs
        outline
        isLast
        onClick={() => fields.push(initialCompetency)}
        disabled={isPublished}
        title={isPublished ? t('Button is disabled because survey already is published') : undefined}
      >
        + {t('Add Competency')}
      </Button>
    </Fragment>
  )
}

export default ReviewsSurveyCompetenciesSection
